export function getDateRange(n): Array<string> {
  const dates: Array<string> = []
  const d = new Date()
  // this following line is added to start with yesterdays data, remove if we want to change to start from today
  d.setDate(d.getDate() - 1)
  while (n--) {
    dates.push(convertDateObjToString(d))
    d.setDate(d.getDate() - 1)
  }
  return dates
}
// Converts a date obj. to a string in format YYY-MM-DD
export function convertDateObjToString(d: Date): string {
  return d.toISOString().substr(0, 10)
}
export function convertToDateString(y, m, d) {
  return y + '-' + m + '-' + d
}

export function getDateForLocalTimeZone() {
  const now = new Date()
  const tzo = -now.getTimezoneOffset()
  const dif = tzo >= 0 ? '+' : '-'
  const pad = function (n, width: number = 2) {
    n = Math.abs(Math.floor(n)) + ''
    return n.length >= width ? n : new Array(width - n.length + 1).join('0') + n
  }
  return (
    now.getFullYear() +
    '-' +
    pad(now.getMonth() + 1) +
    '-' +
    pad(now.getDate()) +
    'T' +
    pad(now.getHours()) +
    ':' +
    pad(now.getMinutes()) +
    ':' +
    pad(now.getSeconds()) +
    '.' +
    pad(now.getMilliseconds(), 3) +
    dif +
    pad(tzo / 60) +
    ':' +
    pad(tzo % 60)
  )
}

export function getDateInterval(timeSetting) {
  const today = new Date()
  today.setDate(today.getDate() - 1)
  const formattedToDate = today.toISOString()
  const fromDate = today
  if (timeSetting === 'WEEK') fromDate.setDate(fromDate.getDate() - 6)
  else if (timeSetting === 'MONTH') fromDate.setDate(fromDate.getDate() - 30)
  else if (timeSetting === 'YEAR') fromDate.setDate(fromDate.getDate() - 365)
  const formattedFromDate = fromDate.toISOString()
  return [formattedFromDate, formattedToDate]
}

export function sameDay(d1, d2) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  )
}

export function getYesterday() {
  const yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return yesterday
}

export function getPreviousMondayAndSunday() {
  const today = new Date()
  const prevMonday = new Date()
  prevMonday.setDate(today.getDate() - 7)
  prevMonday.setDate(prevMonday.getDate() - Math.abs((today.getDay() + 6) % 7))
  const prevSunday = new Date()
  prevSunday.setFullYear(prevMonday.getFullYear())
  prevSunday.setMonth(prevMonday.getMonth())
  prevSunday.setDate(prevMonday.getDate() + 6)
  return [prevMonday, prevSunday]
}

export function getStartAndEndLastMonth() {
  const today = new Date()
  const start = new Date(today.getFullYear(), today.getMonth() - 1, 1, 2)
  const end = new Date(today.getFullYear(), today.getMonth(), 0, 2)
  return [start, end]
}

export function getDaysInMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
}

export function getStartAndEndLastQuarter() {
  const today = new Date()
  const quarter = Math.floor(today.getMonth() / 3)
  const start = new Date(today.getFullYear(), quarter * 3 - 3, 1, 2)
  const end = new Date(start.getFullYear(), start.getMonth() + 3, 0, 2)
  return [start, end]
}

export function getNumberOfDaysBetweenDates(date1, date2) {
  const start = new Date(date1)
  const end = new Date(date2)
  const differenceInTime = end.getTime() - start.getTime()
  const differenceInDays = differenceInTime / (1000 * 3600 * 24)
  return differenceInDays + 1
}

export function getFormattedDateString(dateString) {
  const [date, time] = dateString.split('T')
  if (time) return `${date} ${time.substring(0, 8)}`
  return date
}

export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'Maj',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Okt',
  'Nov',
  'Dec'
]

export const d3SvTimeFormat = {
  dateTime: '%A den %d %B %Y %X',
  date: '%Y-%m-%d',
  time: '%H:%M:%S',
  periods: ['fm', 'em'],
  days: ['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'],
  shortDays: ['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör'],
  months: [
    'Januari',
    'Februari',
    'Mars',
    'April',
    'Maj',
    'Juni',
    'Juli',
    'Augusti',
    'September',
    'Oktober',
    'November',
    'December'
  ],
  shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']
}

export function getQuarterNumber() {
  const date = new Date()
  const quarter = Math.floor(date.getMonth() / 6)
  const lastQuarter = new Date(date.getFullYear(), quarter * 3 - 3, 1)
  const month = lastQuarter.getMonth() + 1
  const nrQuarter = Math.ceil(month / 3)
  return nrQuarter
}

export const monthNamesNew = [
  'Januari',
  'Februari',
  'Mars',
  'April',
  'Maj',
  'Juni',
  'Juli',
  'Augusti',
  'September',
  'Oktober',
  'November',
  'December'
]

// A date as "9 okt 2026" (sv) / "9 Oct 2026" (en): day, short month without the abbreviation dot,
// year. For dates shown in admin lists; never a bare toLocaleString().
export function formatShortDate(value: string | Date, locale: string): string {
  const date = typeof value === 'string' ? new Date(value) : value
  if (Number.isNaN(date.getTime())) return ''
  return new Intl.DateTimeFormat(locale === 'en' ? 'en-GB' : 'sv-SE', {
    day: 'numeric',
    month: 'short',
    year: 'numeric'
  })
    .format(date)
    .replace(/\./g, '')
}

// Calendar days as the backend sends them ('YYYY-MM-DD', no time zone), e.g. license dates.
// Parsed as a local date, so the day shown is the day sent whatever the browser's time zone.
export function parseCalendarDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value)
  if (!match) return null
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]))
}

// "1 jan 2025" (sv) / "1 Jan 2025" (en) for a calendar day; '' for an invalid one.
export function formatCalendarDate(value: string, locale: string): string {
  const date = parseCalendarDate(value)
  return date ? formatShortDate(date, locale) : ''
}

export function toCalendarDate(date: Date): string {
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}

// Today in the browser's time zone, as a calendar day.
export function todayCalendarDate(): string {
  return toCalendarDate(new Date())
}

export function addCalendarDays(value: string, days: number): string {
  const date = parseCalendarDate(value)
  if (!date) return value
  date.setDate(date.getDate() + days)
  return toCalendarDate(date)
}
